import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const addNewBuildingOperations = async (
  buildingName: string,
  onFinish: () => any,
) => {
  try {
    await appApi.addBuilding(buildingName);
    globalSettingsStores.fetchSetting();
    onFinish();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    console.error(
      `addNewBuildingOperations is failed with the buildingsName: ${buildingName}, and the error: ${e}`,
    );
  }
};
